module.exports = __webpack_public_path__ + "img/logo_amazon.e3e3c8e2.png";